export default __webpack_public_path__ + "static/media/chapter_blue.a9ed5827.png";